module.exports = __webpack_public_path__ + "assets/img/umgebindeLand.60a85e9b.svg";